<div class="nav-header">
  <p class="title-text">
    <mat-icon class="header-icon">{{ getTitleIcon() }}</mat-icon>
    <span>{{ getTitleText() }}</span>
  </p>
</div>

<div class="user-config">
  <div class="tooltip visible-label">
    <mat-icon aria-hidden="false">today</mat-icon>
    <span class="visible-text">{{ getDate() }}</span>
    <span class="tooltiptext date">{{ getDate() }}</span>
  </div>
  <div class="tooltip visible-label">
    <mat-icon aria-hidden="false">account_box</mat-icon>
    <span class="visible-text">{{ getUserName() }}</span>
    <span class="tooltiptext user-name">
      <strong>{{ getUserName() }}</strong>
      <br />{{ getUserRole() }}
    </span>
  </div>
  <span (click)="logOut()"><mat-icon aria-hidden="false">exit_to_app</mat-icon></span>
</div>
